import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

export const LotDialogTourConfig: AgTechTourConfig = {
    id: 'lot-dialog-tour',
    name: 'Lot Tour',
    steps: [
        {
            targetId: 'lot-dialog-numbers',
            title: 'Lot Number and Sale Order',
            description: 'Give the lot a unique lot number (up to 10 characters) and set its sale order, the position it will sell in. New lots default to the next available number and order.',
            position: 'bottom',
        },
        {
            targetId: 'lot-dialog-description',
            title: 'Description',
            description: 'Describe the lot as bidders should see it. This appears on the selling grid and on invoices.',
            position: 'bottom',
        },
        {
            targetId: 'lot-dialog-category',
            title: 'Category and Status',
            description: 'Assign a lot category to group similar lots. Status is read-only and reflects whether the lot is unsold, sold or invoiced.',
            position: 'bottom',
        },
        {
            targetId: 'lot-dialog-group',
            title: 'Group Information',
            description: 'Turn on Is Group when the lot represents several animals or items, then enter how many it contains.',
            position: 'top',
        },
    ]
}
